<template>
    <card>
        <template slot="header">
            <h3 class="card-title">{{ title }}</h3>
            <p class="card-category"></p>
        </template>
        <div class="row_chart">
            <div class="col-md-6">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Label</th>
                                <!-- <th>Baseline Value</th> -->
                                <th>Target Value</th>
                                <th>Final Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(label, index) in chartData2.labels" :key="index">
                                <td v-if="label == 'Total'">
                                    <strong>{{ label }}</strong>
                                </td>
                                <td v-if="label != 'Total'">{{ label }}</td>
                                <td>
                                    {{ chartData2.datasets[0].data[index] }}
                                </td>
                                <td>
                                    {{ chartData2.datasets[1].data[index] }}
                                </td>
                                <!-- <td >{{ chartData.datasets[2].data[index] }}</td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- <div class="row">
            <div class="col-md-6">
                <div class="table-responsive">
                    <table class="table chart-legend-table">
                        <tbody>
                            <tr>
                                <td><strong>Name</strong></td>
                                <td class="text-right">
                                    <strong>Total</strong>
                                </td>
                            </tr>
                            <tr
                                v-for="(item, index) in data"
                                :key="index"
                                v-bind:class="{
                                    'has-total':
                                        index == data.length - 1 && hasTotal,
                                }"
                            >
                                <td>{{ $t(item.title) }}</td>
                                <td class="text-right">{{ item.value }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> -->
            <!-- {{ chartData }} -->
            <div class="col-md-6 bpf-chart-holder">
                <!-- {{ chartData2.datasets  }}
                {{ chartData2.datasets[chartData2.datasets.length-2].data[chartData2.datasets[chartData2.datasets.length-2].data.length-1]  }} -->
                <BIToolBarChart :chartData="chartData"
                    :key="chartData2.datasets[chartData2.datasets.length - 2].data[chartData2.datasets[chartData2.datasets.length - 2].data.length - 1]" />

                <!-- <bar-chart
                    :chart-data="computedChartData"
                    :extra-options="chartOptions"
                ></bar-chart> -->
            </div>
            
        </div>
        <!-- <div class="row mt-5">
            <div class="col-12">
                <base-button @click="exportExcell()" type="default" size="lg" class="btn-fill">
                    Export
                </base-button>
            </div>
        </div> -->
    </card>
</template>
<style lang="scss">

.row_chart {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-evenly;
}

.bpf-chart-holder {
    display: flex;
    justify-content: center;
}

#pie-chart {
    /* width: 80% !important;
        height: auto !important; */
    margin: auto;
}

.chart-legend-table tbody tr {
    td:first-child {
        position: relative;
        padding-left: 37px;
    }

    td:first-child:before {
        content: "";
        // position: relative;
        // top: 4px;
        position: absolute;
        top: 12px;
        left: 7px;
        // position: absolute;
        // top: 0;
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 10px;

        // background-color: #ff6384;
    }

    &:nth-child(2) td:first-child:before {
        background-color: #ff6384;
    }

    &:nth-child(3) td:first-child:before {
        background-color: #ffcd56;
    }

    &:nth-child(4) td:first-child:before {
        background-color: #36a2eb;
    }

    &:nth-child(5) td:first-child:before {
        background-color: #8ceb36;
    }

    &:nth-child(6) td:first-child:before {
        background-color: #6393ff;
    }

    &:nth-child(7) td:first-child:before {
        background-color: #9863ff;
    }

    &:nth-child(8) td:first-child:before {
        background-color: #4e0013;
    }

    &:nth-child(9) td:first-child:before {
        background-color: #74132c;
    }

    &:nth-child(10) td:first-child:before {
        background-color: #003925;
    }

    &:nth-child(11) td:first-child:before {
        background-color: #267257;
    }

    &:nth-child(12) td:first-child:before {
        background-color: #0e553c;
    }

    &:nth-child(13) td:first-child:before {
        background-color: #b0b6f2;
    }

    &:nth-child(14) td:first-child:before {
        background-color: #c8bef3;
    }

    &:nth-child(15) td:first-child:before {
        background-color: #dbc7f3;
    }

    &:nth-child(16) td:first-child:before {
        background-color: #ebd2f4;
    }

    &:nth-child(17) td:first-child:before {
        background-color: #d8eb67;
    }

    &:nth-child(18) td:first-child:before {
        background-color: #a05195;
    }

    &:nth-child(19) td:first-child:before {
        background-color: #d45087;
    }

    &:nth-child(20) td:first-child:before {
        background-color: #ffa600;
    }
}

.chart-legend-table tbody tr.has-total td:first-child {
    font-weight: bold;

    &:before {
        display: none;
    }
}
</style>
<script>
import BIToolBarChart from "@/components/Charts/BIToolBarChart2.js";
import {
    LogMonitoringService,
} from "@/services";
//   C:\JOB\Best2\Dev\iucn-best-2\src\components\Charts\BIToolBarChart2.js

export default {
    name: "BarChartCard",
    components: {
        BIToolBarChart,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        },
        // form: {
        //     type: Object,
        //     required: true,
        // },
        type: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            keyValue: 0,
        }
    },
    methods: {
       
    },
    computed: {
        chartData() {
            if (this.type == "octs") {
                return {
                    labels: this.data.dataOctsTarget.map((data) => {
                        if (data.title != "Total") {
                            return data.title;
                        } else {
                            return "";
                        }
                    }),
                    datasets: [
                        // {
                        //     label: "Baseline",
                        //     data: this.data.dataBaseline.map((data) => data.value),
                        //     backgroundColor: "#ffcd56",
                        // },
                        {
                            label: "Target",
                            data: this.data.dataOctsTarget.map((data) => {
                                if (data.title != "Total") {
                                    return data.value;
                                } else {
                                    return "";
                                }
                            }),
                            backgroundColor: "#ff6384",
                        },
                        {
                            label: "Final",
                            data: this.data.dataOctsFinal.map((data) => {
                                if (data.title != "Total") {
                                    return data.value;
                                } else {
                                    return "";
                                }
                            }),
                            backgroundColor: "#36a2eb",
                        },
                    ],
                };
            } else {
                return {
                    labels: this.data.dataTarget.map((data) => {
                        if (data.title != "Total") {
                            return data.title;
                        } else {
                            return "";
                        }
                    }),
                    datasets: [
                        // {
                        //     label: "Baseline",
                        //     data: this.data.dataBaseline.map((data) => data.value),
                        //     backgroundColor: "#ffcd56",
                        // },
                        {
                            label: "Target",
                            data: this.data.dataTarget.map((data) => {
                                if (data.title != "Total") {
                                    return data.value;
                                } else {
                                    return "";
                                }
                            }),
                            backgroundColor: "#2dce89",
                        },
                        {
                            label: "Final",
                            data: this.data.dataFinal.map((data) => {
                                if (data.title != "Total") {
                                    return data.value;
                                } else {
                                    return "";
                                }
                            }),
                            backgroundColor: "#11cdef",
                        },
                    ],
                };
            }
            // }.splice();
        },
        chartData2() {
            if (this.type == "octs") {
                return {
                    labels: this.data.dataOctsTarget.map((data) => data.title),
                    datasets: [
                        // {
                        //     label: "Baseline",
                        //     data: this.data.dataBaseline.map((data) => data.value),
                        //     backgroundColor: "#ffcd56",
                        // },
                        {
                            label: "Target",
                            data: this.data.dataOctsTarget.map(
                                (data) => data.value
                            ),
                            backgroundColor: "#ff6384",
                        },
                        {
                            label: "Final",
                            data: this.data.dataOctsFinal.map((data) => data.value),
                            backgroundColor: "#36a2eb",
                        },
                    ],
                };
            } else {
                return {
                    labels: this.data.dataTarget.map((data) => data.title),
                    datasets: [
                        // {
                        //     label: "Baseline",
                        //     data: this.data.dataBaseline.map((data) => data.value),
                        //     backgroundColor: "#ffcd56",
                        // },
                        {
                            label: "Target",
                            data: this.data.dataTarget.map(
                                (data) => data.value
                            ),
                            backgroundColor: "#ff6384",
                        },
                        {
                            label: "Final",
                            data: this.data.dataFinal.map((data) => data.value),
                            backgroundColor: "#36a2eb",
                        },
                    ],
                };
            }
        },
    },
};
</script>
